import Chart from 'chart.js/auto';
import Vue from "vue";

const ChartDefaults = {
  install(Vue) {
    Chart.defaults.font.family = "Poppins"
    Chart.defaults.color = '#000'
    Chart.defaults.font.size = 12
  }
}

Vue.use(ChartDefaults)

export default ChartDefaults;